import { useContext } from 'react'
import CartContext from './cart-context'

/**
 * useCart
 * The custom hook which provided to external use via context
 */
const useCart = () => {
  const context = useContext(CartContext);
  return context
};

export default useCart;
